import { NextPage, GetServerSideProps, GetServerSidePropsResult } from 'next'
import React from 'react'
import { NextSeo } from 'next-seo'
import { envVars } from 'src/utils/env'
import { ExternalPath } from 'src/modules/path'
import { PublicGrpcClient } from '@singcolor/grpc-client'
import { GetLiveOgpInfoV1Response } from '@singcolor/grpc-client/src/singcolor-proto/ts/public_v1_pb'
import { AppCustomUrlSchemeLauncher } from 'src/components/organisms/AppCustomUrlSchemeLauncher'
import { ShareLiverInfo } from 'src/components/organisms/ShareLiverInfo'

type Props = {
  liveId: string
  liverName: string
  liverProfileImageUrl: string | undefined
}

const Page: NextPage<Props> = ({ liveId, liverName, liverProfileImageUrl }: Props) => {
  const title = '歌配信アプリ ColorSing'
  const description = `${liverName}が配信中！↓のOPENをタップしてみよう`
  const url = `${envVars.webUrl}/share/live?live_id=${liveId}`

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          type: 'website',
          url,
          title,
          description,
          images: liverProfileImageUrl ? [{ url: liverProfileImageUrl }] : []
        }}
        twitter={{ cardType: 'summary_large_image' }}
      />
      <AppCustomUrlSchemeLauncher
        customScheme={`${envVars.appCustomUrlScheme}live?live_id=${liveId}`}
        disableFallback={true}
      />

      <ShareLiverInfo liverName={liverName} liverProfileImageUrl={liverProfileImageUrl} />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ query }): Promise<GetServerSidePropsResult<Props>> => {
  let liveId = query.live_id
  if (typeof liveId !== 'string') {
    return { redirect: { statusCode: 302, destination: ExternalPath.lp } }
  }

  // grpc-webをサーバーサイドで動かすにはXMLHttpRequestをポリフィルする必要がある（無理矢理）
  global.XMLHttpRequest = require('xhr2')

  const publicGrpcClient = new PublicGrpcClient(async () => ({ 'X-SINGCOLOR-PLATFORM': 'Web(Server Side)' }))
  const liveInfo = await publicGrpcClient
    .getLiveOgpInfo({ liveId })
    .then(res => res as GetLiveOgpInfoV1Response.AsObject)

  return {
    props: {
      liveId,
      liverName: liveInfo.liverName,
      liverProfileImageUrl: liveInfo.liverProfileImageUrls?.large
    }
  }
}

export default Page
